export const TABLE_COLUMNS_NUMBER = 4;

export const tableConfig = {
  formBundleName: {
    label: 'Form Bundle',
    width: '26%',
    colSpan: ({ formBundleName }) => formBundleName?.colSpan,
    customStyles: ({ formBundleName }) => formBundleName?.customStyles,
    content: ({ formBundleName }) => formBundleName?.content ?? 'Form Bundle',
  },
  createdDate: {
    label: 'Date sent',
    width: '30%',
    content: () => 'Date sent',
  },
  isSignable: {
    label: 'E-Signed',
    width: '22%',
    content: () => 'E-Signed',
  },
  acknowledgedDate: {
    label: 'Acknowledged',
    width: '22%',
    content: () => 'Acknowledged',
  },
};
